var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46483 14.4733C3.40251 13.5356 4.67428 13.0088 6.00037 13.0088H14.0004C15.3264 13.0088 16.5982 13.5356 17.5359 14.4733C18.4736 15.4109 19.0004 16.6827 19.0004 18.0088V20.0088C19.0004 20.5611 18.5527 21.0088 18.0004 21.0088C17.4481 21.0088 17.0004 20.5611 17.0004 20.0088V18.0088C17.0004 17.2131 16.6843 16.4501 16.1217 15.8875C15.5591 15.3249 14.796 15.0088 14.0004 15.0088H6.00037C5.20472 15.0088 4.44166 15.3249 3.87905 15.8875C3.31644 16.4501 3.00037 17.2131 3.00037 18.0088V20.0088C3.00037 20.5611 2.55265 21.0088 2.00037 21.0088C1.44808 21.0088 1.00037 20.5611 1.00037 20.0088V18.0088C1.00037 16.6827 1.52715 15.4109 2.46483 14.4733Z",
    fill: "#BB85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 3.00879C8.34351 3.00879 7.00037 4.35193 7.00037 6.00879C7.00037 7.66564 8.34351 9.00879 10.0004 9.00879C11.6572 9.00879 13.0004 7.66564 13.0004 6.00879C13.0004 4.35193 11.6572 3.00879 10.0004 3.00879ZM5.00037 6.00879C5.00037 3.24737 7.23894 1.00879 10.0004 1.00879C12.7618 1.00879 15.0004 3.24737 15.0004 6.00879C15.0004 8.77021 12.7618 11.0088 10.0004 11.0088C7.23894 11.0088 5.00037 8.77021 5.00037 6.00879Z",
    fill: "#BB85FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUser);
export default __webpack_public_path__ + "static/media/menu-user.c890e6b914f177bd12afbca23ceb0d21.svg";
export { ForwardRef as ReactComponent };